/**
 * Shim fino — delega para `@pps/observability` (IR-OBS-001).
 * Não adicionar lógica aqui. Configurar via parâmetros de `initSentry`.
 */
import { initSentry, Sentry } from "@pps/observability";

initSentry({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.VITE_APP_ENV ?? import.meta.env.MODE,
  app: "crm",
});

export { Sentry };
